export const bg_util_debounce = (time, fn) => {
  let timeout;
  return function () {
    const callFunc = () => fn.apply(this, arguments);
    clearTimeout(timeout);
    timeout = setTimeout(callFunc, time);
  };
};
